import { makeAutoObservable } from 'mobx';
import type { OAuth2FieldsStore } from 'areas/administration/authentication/oauth2/components/oauth2-fields/oauth2FieldsStore';

export const OAUTH2_RFC6749_TYPE = 'OAUTH2RFC6749';
export class OAuth2Authentication {
	authorizationServer = '';
	clientIdentifier = '';
	clientSecret = '';
	hasClientSecret = false;
	scope = '';
	username = '';
	password = '';
	hasPassword = false;
	clearPassword = false;

	constructor(record?: Partial<OAuth2Authentication>) {
		makeAutoObservable(this);

		if (record) {
			this.authorizationServer = record.authorizationServer ?? '';
			this.clientIdentifier = record.clientIdentifier ?? '';
			this.hasClientSecret = !!record.hasClientSecret;
			this.scope = record.scope ?? '';
			this.username = record.username ?? '';
			this.hasPassword = !!record.hasPassword;
		}
	}
}

export type OAuth2FieldsProps = {
	store: OAuth2FieldsStore;
};
